/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import { ApplicationContext } from '@/v2/state/providers';
import TimeLineItem from '@/v2/components/layouts/TimeLineItem';

import './TimeLine.scss';

const getLanguage = () =>
    navigator.userLanguage ||
    (navigator.languages && navigator.languages.length && navigator.languages[0]) ||
    navigator.language ||
    navigator.browserLanguage ||
    navigator.systemLanguage ||
    'en';

// Check if date matches dd-mm-yyyy format
const isExpectedDateFormat = (dateString) => dateString.match(/^([0]?[1-9]|[1|2][0-9]|[3][0|1])[-]([0]?[1-9]|[1][0-2])[-]([0-9]{4}|[0-9]{2})$/);

const stringToDate = (dateString) => {
    if (!isExpectedDateFormat(dateString)) {
        return dateString;
    }

    const [dd, mm, yyyy] = dateString.split('-');
    const date = new Date(`${yyyy}`, `${mm - 1}`, `${dd}`);
    return date;
};

const TimeLine = () => {
    const [data] = useContext(ApplicationContext);
    const events = data?.register.text.events;
    const arrEvents = JSON.parse(JSON.stringify(events));

    const lang = getLanguage();
    const currMonth = new Date().getMonth();
    let activeEvent = false;

    arrEvents.map((event) => {
        const isDate = isExpectedDateFormat(event.date);
        const newDate = isDate ? stringToDate(event.date) : event.date;
        let active = false;

        if (isDate && currMonth === newDate.getMonth()) {
            active = true;
            activeEvent = true;
        }

        if (isDate && currMonth < newDate.getMonth() && activeEvent !== true) {
            active = true;
            activeEvent = true;
        }

        event.date = newDate;
        event.active = active;
        return event;
    });

    return (
        <aside className="TimeLine">
            <ul className={`TimeLine__list TimeLine--listOf-${arrEvents.length}`}>
                {arrEvents.map((event, i) => (
                    <TimeLineItem
                        date={event.date.toLocaleString(lang, { month: 'long', year: 'numeric' })}
                        eventName={event.name}
                        active={event.active}
                        key={`event - ${i}`}
                    />
                ))}
            </ul>
        </aside>
    );
};

export default TimeLine;
